import { makeStyles } from '@material-ui/core/styles';


export default makeStyles((theme) => ({
    box: {
        marginTop: '200px',
        marginBottom: '210px'
    },
    title: {
        fontFamily: 'Montserrat, cursive, Arial '
    },
    container: {
        display: 'flex',
        height: '150%',
        flexDirection: 'column',
        justifyContent: 'flex-start',
    },
    footer: {
        height: '150%',
        marginTop: 'auto'
    }
}));
